module.exports = __webpack_public_path__ + "static/posterbackground-a2e0d90c708d72056927712ab901695e.jpg";